import React from "react";

export default function FileOpen({ fill = "#FAFAFA", width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.66 6.87C17.5794 6.75293 17.4709 6.6578 17.3444 6.59319C17.2178 6.52859 17.0771 6.49656 16.935 6.5H5.585C5.34551 6.51016 5.11355 6.58658 4.91492 6.72076C4.7163 6.85494 4.55881 7.04162 4.46 7.26C4.45836 7.28331 4.45836 7.3067 4.46 7.33L3 12.5V3.5H6.245L7.55 5.295C7.59655 5.3587 7.65751 5.41048 7.7279 5.44611C7.79829 5.48174 7.87611 5.50021 7.955 5.5H16C16 5.23479 15.8946 4.98043 15.7071 4.7929C15.5196 4.60536 15.2652 4.5 15 4.5H8.21L7.055 2.91C6.96191 2.78261 6.83999 2.67905 6.69921 2.60779C6.55843 2.53653 6.40279 2.49959 6.245 2.5H3C2.73478 2.5 2.48043 2.60536 2.29289 2.7929C2.10536 2.98043 2 3.23479 2 3.5V14.845C2.00781 15.0249 2.08616 15.1946 2.21811 15.3172C2.35006 15.4397 2.52498 15.5054 2.705 15.5H15.17C15.2816 15.5044 15.3914 15.4714 15.482 15.4062C15.5727 15.3409 15.6388 15.2472 15.67 15.14L17.765 7.59C17.8041 7.47 17.8149 7.3426 17.7967 7.21772C17.7785 7.09284 17.7317 6.97384 17.66 6.87ZM14.775 14.5H3.45L5.39 7.595C5.43734 7.53401 5.50458 7.49154 5.58 7.475H16.745L14.775 14.5Z'
        fill={fill}
      />
    </svg>
  );
}
